import { render, staticRenderFns } from "./management-inventory-import-form.vue?vue&type=template&id=1a8e1606"
import script from "./management-inventory-import-form.vue?vue&type=script&lang=js"
export * from "./management-inventory-import-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports